// extracted by mini-css-extract-plugin
export default {"container":"PreviewDrawer_container__ojK-s","previewContainer":"PreviewDrawer_previewContainer__7JjQc","footer":"PreviewDrawer_footer__ichyc","pdfTip":"PreviewDrawer_pdfTip__TELp1"};